import classNames from 'classnames';
import React from 'react';
import WithDictionaries, { IWithDictionaries } from '../../../components/hoc/withDictionaries';
import TextIcon from '../../../components/textIcon';
import { TDocumentStatusOptions } from '../../../interfaces/dict';
import { DOCUMENT_STATUS_VISUAL } from '../../../interfaces/document';

interface IDocumentRoStatusProps extends IWithDictionaries, React.AllHTMLAttributes<HTMLDivElement> {
	status: TDocumentStatusOptions;
	withCaption?: boolean;
	withTextColors?: boolean;
	withIcons?: boolean;
}
const DocumentRoStatus = ({
	status,
	staticOptions,
	className,
	withCaption,
	withTextColors,
	withIcons,
}: IDocumentRoStatusProps) => {
	return (
		<span
			className={classNames('text-nowrap', withTextColors && `text-${DOCUMENT_STATUS_VISUAL[status].color}`, className)}
			title="Статус документа"
		>
			{withCaption && <>Статус: </>}
			{withIcons && <TextIcon Icon={DOCUMENT_STATUS_VISUAL[status].Icon} className="me-1" />}
			{staticOptions.DOCUMENT_STATUS ? staticOptions.DOCUMENT_STATUS[status] : status}
		</span>
	);
};

export default WithDictionaries(DocumentRoStatus);
